import { render, staticRenderFns } from "./gyroscope-button.vue?vue&type=template&id=2da5b75b&scoped=true&"
import script from "./gyroscope-button.vue?vue&type=script&lang=js&"
export * from "./gyroscope-button.vue?vue&type=script&lang=js&"
import style0 from "./gyroscope-button.vue?vue&type=style&index=0&id=2da5b75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5b75b",
  null
  
)

export default component.exports